<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="statuschange"
    ref="statuschange"
    body-class="bg-white"
    cancel-title="Close"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Ok':'Ok'"
    title="Change Status"
    @ok="handleOk"
    :ok-disabled="submitted"
  >
    <p>Are you sure you want to {{this.status=='1'?'Inactive':'Active'}} the selected product ?</p>
  </b-modal>
</template> 
<script>
import store from "@/store/index";
export default {
  props: ["module", "id", "statuschange", "status"],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      check: false
    };
  },
  methods: {
    async handleOk() {
      var data = {
        name: this.statuschange,
        id: this.id
      };
      await store
        .dispatch(this.module + "/singlestatus", data)
        .then(response => {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.status,
            type: response.data.type,
            showCloseButton: true
          });

             if (response.data.code == 200&&this.statuschange=='active') {
           this.$emit("active_status");
        }
        else if (response.data.code == 200&&this.statuschange=='inactive'){
          this.$emit("inactive_status")
        }
        });
    }
  }
};
</script>